module.exports = __webpack_public_path__ + "img/website-boosting.2e1094cf.jpg";